import { Group, Stack, createStyles } from '@mantine/core';
import { format, isDate } from 'date-fns';

import dt from '~/testing';
import { Text } from '~/domains/design-system/Text';

import { pluralizeSlateLabel } from '../../../utils/pluralizeSlateLabel';

import type { SegmentsSegmentType } from './types';

const useViewStyles = createStyles((theme) => ({
  segment: {
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    padding: `${theme.spacing.xs}px 0`,
  },
}));

export function SegmentsView({
  segments,
  slateLabel = 'Tournaments',
}: {
  segments: SegmentsSegmentType[];
  slateLabel?: string;
}) {
  const { classes, theme } = useViewStyles();

  return (
    <>
      {segments.map((segment) => (
        <Group
          key={segment.key}
          position="apart"
          className={classes.segment}
          data-test-id={dt.contest.create.segments.view.segment}
        >
          <Text variant="body-large" c={theme.colors.gray[7]}>
            {segment.label}
          </Text>
          <Stack spacing={theme.other.spacing._2} ta="right">
            <Text variant="body-large" c={theme.colors.gray[7]}>
              {segment.items.length} {pluralizeSlateLabel(segment.items.length, slateLabel)}
            </Text>
            <Text variant="body-large" c={theme.colors.gray[7]}>
              {isDate(segment.items[0]?.date) ? (
                <>{format(segment.items[0]?.date, 'M/dd')} - </>
              ) : null}
              {isDate(segment.items[segment.items.length - 1]?.date) ? (
                <>{format(segment.items[segment.items.length - 1]?.date, 'M/dd')} </>
              ) : null}
            </Text>
          </Stack>
        </Group>
      ))}
    </>
  );
}
